import { Organization } from '../../interfaces/api/organization';
import { getOrganization, getOrganizations } from '../../api/organizations';

export async function fetchOrganizations(): Promise<Organization[]> {
	try {
		return await getOrganizations();
	} catch (error) {
		throw error;
	}
}

export async function fetchOrganization(id: number): Promise<Organization> {
	try {
		return await getOrganization(id);
	} catch (error) {
		throw error;
	}
}
